import { axiosInstanceWebsitePublic } from "@/services/instance";
import type { OnboardingStatusResponse } from "../types/onboardingStatus.types";

function normalizeOnboardingStatusResponse(data: any): OnboardingStatusResponse {
  if (typeof data?.requires_onboarding === "boolean") return data;
  if (typeof data?.data?.requires_onboarding === "boolean") return data.data;
  return { requires_onboarding: false, reason: "unknown" };
}

export const onboardingStatusService = {
  async getByEmail(email: string): Promise<OnboardingStatusResponse> {
    const safeEmail = encodeURIComponent(email.trim());
    const response = await axiosInstanceWebsitePublic.get(
      `/user/detail/onboarding-status/${safeEmail}`
    );
    return normalizeOnboardingStatusResponse(response.data);
  },
};


